import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NotificationModule } from "libraries/component/notification/notification.module";
import { CostWarningComponent } from "./cost-warning.component";
import { BtnModule } from "libraries/ui_button/btn.module";
import { WarningsResourceModule } from "app_quotation/shared/resources/warnings/warnings-resource.module";
import { LoaderModule } from "libraries/component/loader/loader.module";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";

@NgModule({
    imports: [
        CommonModule,
        NotificationModule,
        BtnModule,
        WarningsResourceModule,
        LoaderModule,
        FontAwesomeModule,
    ],
    exports: [
        CostWarningComponent,
    ],
    declarations: [
        CostWarningComponent,
    ]
})
export class CostWarningModule {}